// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"35d52b13e94508f7","5763":"07ec0835f5a1c991","6893":"5d07bf9e6b72c00a","6974":"7ac744e5b733f6f1","7222":"4364af41778897b1","7937":"d0555d6427fd7f08"}[chunkId] + ".js";
};